import { Link } from 'react-router-dom';

const entries = [
  {
    type: 'tv',
    label: '电视剧',
    desc: '追最新热播剧集',
    icon: 'ri-tv-2-line',
    tone: 'primary' as const,
  },
  {
    type: 'movie',
    label: '电影',
    desc: '精选高分佳片',
    icon: 'ri-film-line',
    tone: 'accent' as const,
  },
  {
    type: 'variety',
    label: '综艺',
    desc: '欢乐下饭综艺',
    icon: 'ri-mic-line',
    tone: 'secondary' as const,
  },
];

const toneMap = {
  primary: {
    wrap: 'bg-primary-500',
    icon: 'text-primary-50',
    badge: 'bg-primary-100 text-primary-700',
  },
  accent: {
    wrap: 'bg-accent-500',
    icon: 'text-accent-950',
    badge: 'bg-accent-100 text-accent-800',
  },
  secondary: {
    wrap: 'bg-secondary-500',
    icon: 'text-secondary-50',
    badge: 'bg-secondary-100 text-secondary-800',
  },
};

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {entries.map((entry) => {
        const tone = toneMap[entry.tone];
        return (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group flex items-center gap-4 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className={`w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg flex items-center justify-center ${tone.wrap}`}>
              <i className={`${entry.icon} text-2xl md:text-3xl ${tone.icon}`} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="text-base md:text-lg font-bold text-foreground-950">{entry.label}</h3>
                <span className={`px-2 py-0.5 rounded-md text-[11px] font-medium ${tone.badge}`}>
                  频道
                </span>
              </div>
              <p className="mt-1 text-xs md:text-sm text-foreground-500">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-line text-xl text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-1 transition-all shrink-0" />
          </Link>
        );
      })}
    </div>
  );
}